export const GET_TOURS = 'GET_TOURS';
export const SET_CURRENT_TOUR = 'SET_CURRENT_TOUR';
export const SET_CURRENT_LOCATION = 'SET_CURRENT_LOCATION';
export const SET_CURRENT_POINT = 'SET_CURRENT_POINT';
export const SET_CURRENT_GEO_LOCATION = 'SET_CURRENT_GEO_LOCATION';
export const SET_AUDIO_STATUS = 'SET_AUDIO_STATUS';
export const SET_SIDE_MENU_STATUS = 'SET_SIDE_MENU_STATUS';
export const PAGE_IS_LOADING = 'PAGE_IS_LOADING';
export const PAGE_LOADING_COMPLETE = 'PAGE_LOADING_COMPLETE';


// WEBPACK FOOTER //
// ./src/actions/types.js